import React, { useCallback } from 'react';
import Typography from '@material-ui/core/Typography';
import { Accordion, AccordionSummary, AccordionDetails } from '@material-ui/core'
import clsx from 'clsx';
import { useHistory } from "react-router-dom";

import useStyles from '../../styles/components/news/stylesLastestNewsHolder'
import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'
import { News } from '../../utils/services/cache/ClientCache'

const LatestNewsHolder = ({ news }) => {
    const classes = useStyles();
    const history = useHistory()
    const handleBody = () => {
        let result = news?.body?.replace(/(<([^>]+)>)/ig, '').trim();
        const arr = (result?.split('&nbsp;').join(' '))?.split(' ').join(' ')
        return arr
    }

    const handleClick = useCallback(() => {
        News.setNewsId(news.id)
        history.push('/NewsDetail')
    }, [])

    return (
        <div style={{ width: '100%', marginBottom: '20px' }}>
            <Accordion expanded={true} classes={{ root: classes.rootAccordion }} style={{ cursor: 'pointer' }} onClick={handleClick}>
                <AccordionSummary classes={{ root: classes.rootAccordionSummary, content: classes.contentAccordionSummary }}>
                    <img src={news?.bannerUrl} alt={news?.title} className={classes.image} />
                </AccordionSummary>
                <AccordionDetails classes={{ root: classes.rootAccordionDetails }}>
                    <Typography className={clsx(classes.rootTypographyTitle, classes.containText)}> {news?.title} </Typography>
                    <Typography className={clsx(classes.rootTypographyBody, classes.containText)}>{handleBody()}</Typography>
                    {news?.updatedDate ?
                        <Typography classes={{ root: classes.rootTypographyDate }}>{ConvertDateString.convertForDatePicker(news?.updatedDate)}</Typography>
                        :
                        <Typography classes={{ root: classes.rootTypographyDate }}>{ConvertDateString.convertForDatePicker(news?.createdDate)}</Typography>
                    }
                </AccordionDetails>
            </Accordion>
        </div>
    );
};

export { LatestNewsHolder as default }